import { lazy, StrictMode, Suspense } from "react";
import ReactDOM from "react-dom/client";
import log from "loglevel";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { createTheme, ThemeProvider } from "@mui/material";
import { LoadingSpinner, muiTheme } from "@covema-vernici/components";
import { LicenseInfo } from "@mui/x-license";
import { reportWebVitals } from "./reportWebVitals";
import { getConfig } from "./config";
import { SuppressDevOverlay } from "./app/utils/SuppressDevOverlay";

const licenseKey = getConfig().muiXProLicense;
LicenseInfo.setLicenseKey(licenseKey || "");

const App = lazy(
  () =>
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName App */
      "./App"
    ),
);

log.setDefaultLevel(log.levels.TRACE);

// TODO: web-vitals

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);

export const theme = createTheme(muiTheme, {
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          flexDirection: "row-reverse",
          gap: "8px",
          "& .MuiAccordionSummary-expandIconWrapper": {
            transform: "rotate(0deg)",
            transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          },
          "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)",
          },
        },
      },
    },
  },
});

root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <SuppressDevOverlay />
      <Suspense fallback={<LoadingSpinner variant="absolute" />}>
        <App />
      </Suspense>
    </ThemeProvider>
  </StrictMode>,
);

reportWebVitals();
